import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: IdleTimeoutTypes, Creators: IdleTimeoutActions } = createActions(
  {
    idleChange: ['isIdle'],
  },
  { prefix: 'IDLE_TIMEOUT_' }
);

export const INITIAL_STATE = Immutable({
  isIdle: false,
});

const handleIdleChange = (state, { isIdle }) => state.set('isIdle', isIdle);

export const reducer = createReducer(INITIAL_STATE, {
  [IdleTimeoutTypes.IDLE_CHANGE]: handleIdleChange,
});
